import { UPDATE_THONGTIN_CUAHANG } from "actions/DanhSachCuaHang/actionTypes";
const initialState = {
  CuaHangId: "",
  TenCuaHang: "",
  MaCuaHang: "",
  SoDienThoai: "",
  DiaChi: "",
  TrangThai: "",
};

const updateThongTin = (state, action) => ({
  ...action.payload,
});

export const addAndEditCuaHangReducer = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_THONGTIN_CUAHANG:
      return updateThongTin(state, action);
    default:
      return state;
  }
};

export default addAndEditCuaHangReducer;
